var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _rect3, _rect4, _circle, _circle2, _circle3, _path8, _path9, _circle4, _circle5, _path10, _circle6, _circle7, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 339.57 267.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 208.13,
    y1: 159.3,
    x2: 204.59,
    y2: -27.35,
    gradientTransform: "matrix(1 0 0 -1 0 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 288.64,
    y1: 202.89,
    x2: 13.93,
    y2: 349.2,
    gradientTransform: "matrix(.99 .15 .15 -.99 -62.69 393.03)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 248.05,
    y1: 113.67,
    x2: -26.67,
    y2: 259.99,
    gradientTransform: "matrix(1 0 0 -1 .67 351.09)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 221.63,
    y1: 112.89,
    x2: 64.53,
    y2: 226.45,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 156.58,
    y1: 61.25,
    x2: 328.35,
    y2: 248.1,
    gradientTransform: "matrix(1 0 0 -1 -37.28 314.28)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 361,
    y1: 234.08,
    x2: 97.8,
    y2: 42.03,
    gradientTransform: "matrix(1 0 0 -1 -37.28 314.28)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 266.16,
    y1: 186.63,
    x2: 271.3,
    y2: 57.05,
    gradientTransform: "matrix(1 0 0 -1 -37.28 314.28)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 226.07,
    y1: 181.82,
    x2: 280.64,
    y2: 57.67,
    gradientTransform: "matrix(1 0 0 -1 -37.28 314.28)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 160.3,
    y1: 106.52,
    x2: 69.87,
    y2: 86.74,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 326.77,
    y1: 266.36,
    x2: 143.17,
    y2: 2.75,
    gradientTransform: "matrix(1 0 0 -1 0 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M337.98 197.72c-3.84-16.83-15.92-27.47-21.36-43.67-4.54-13.54-3.59-28.27-6.23-42.3-5.1-27.12-23.6-50.31-46-66.42s-48.67-26-74.77-34.84C179.3 7 168.81 3.62 158.12 1.68a99.23 99.23 0 00-16.4-1.67c-28.54-.37-54.65 14.49-73.8 34.83-8.63 9.2-20.09 22.13-23.89 34.44-4.39 14.21-.3 30.51-4.44 45.21-3.35 11.88-11 22-17.81 32.26-15.34 23-27.73 51.59-18.75 77.74 7.82 22.79 30.87 37.96 54.69 41.79s48.13-2.09 70.59-10.79c14.68-5.68 29.43-12.69 45.17-12.62 14.62.06 28.41 6.22 42.34 10.65a183.38 183.38 0 0076.55 7.31c10.26-1.21 20.76-3.43 29.21-9.38 16.2-11.47 20.82-34.36 16.4-53.73z",
    fill: "#4b39ef",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.93 260.91a334.85 334.85 0 00-65.54 14.55c-2.42.8-5.14 1.93-5.9 4.36a342 342 0 0069.64 1.72c15.24-1.18 30.39-3.38 45.63-4.48 32.11-2.32 64.48.26 96.49-3.22a10.48 10.48 0 004.55-1.23 3.68 3.68 0 001.78-4 4.8 4.8 0 00-2.63-2.46c-5.38-2.67-11.64-2.72-17.65-2.64-40.54.55-81.31 4.82-121.48-.68",
    transform: "translate(-37.28 -37.72)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.86 115.02c-17-7.87-34.81-15.6-53.52-15.11-6.88.18-13.71 1.48-20.6 1.52a57 57 0 01-32.24-9.82q-7.71 26.58-15.28 53.2c-1.39 4.89-3.24 9.9-4.16 14.9-1.52 8.27 17.19 12.4 23.21 13.16 6.94.88 14 .2 21 .43a40.32 40.32 0 0117.19 4c5.22 2.66 11.3 4.13 16.86 6.22 13.69 5.13 28.13 9.54 42.69 8.23s29.34-9.55 34.51-23.22c1.23-3.25 1.89-6.69 3-10 2.86-8.35 11.94-19.24 2.38-26.13-10.18-7.41-23.64-12.12-35.04-17.38z",
    fill: "#4b39ef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.21 154.31c-7.27-3.31-14.52-6.82-22.29-8.69-18.61-4.45-38.59.89-57.09-4a8.12 8.12 0 01-10.71 4.13h-.05c-.85 3.33-.83 7.37-1.49 10.88q-1.24 6.52-2.93 12.95a196.37 196.37 0 01-8.3 24.78c1.66-.17 3.06 1.45 3.28 3.11a9.88 9.88 0 01-1 4.84c-.11.26 5.35 1.9 5.87 2a25.09 25.09 0 006 0c4.34-.35 8.56-1.6 12.87-2.2 16.27-2.26 32.17 4.78 48.06 9a139.63 139.63 0 0016.21 3.25c3.92.55 7.94.92 11.8 0s7.61-3.11 11-5.48c6.49-4.56 12.52-10 16.75-16.67 3.37-5.34 9.76-19.52 3.46-24.72-3.76-3.1-10.87-4.4-15.4-6.27q-8.11-3.3-16.04-6.91z",
    transform: "translate(-37.28 -37.72)",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.98 119.28c-18-5.12-36.82-10-55.22-6.57-6.78 1.26-13.32 3.61-20.11 4.73a57 57 0 01-33.39-4.68q-3.47 27.47-6.78 54.94c-.61 5.05-1.65 10.28-1.78 15.37-.21 8.4 18.91 9.56 25 9.37 7-.22 13.84-2 20.78-2.85a39.93 39.93 0 0117.62 1.2c5.57 1.8 11.81 2.31 17.63 3.5 14.32 2.93 29.27 5 43.45 1.47s27.48-14 30.46-28.33c.7-3.4.82-6.9 1.42-10.32 1.53-8.7 8.8-20.87-1.73-26.18-11.28-5.65-25.27-8.19-37.35-11.65z",
    fill: "#4b39ef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.73 160.59c-7.7-2.14-15.41-4.47-23.37-5.1-19.08-1.49-38 6.91-57 5a8.13 8.13 0 01-10 5.75c-.32 3.43.33 7.41.22 11-.14 4.42-.43 8.85-.87 13.25a195.22 195.22 0 01-4.33 25.77c1.62-.43 3.26 1 3.73 2.56a9.86 9.86 0 01-.27 4.94c-.07.28 5.58 1.05 6.11 1.05a25 25 0 005.89-.89c4.24-1 8.21-2.91 12.37-4.18 15.72-4.77 32.52-.3 48.86 1.34a140.17 140.17 0 0016.52.68c4-.08 8-.33 11.66-1.8 3.83-1.52 7-4.26 10-7.13 5.69-5.52 10.81-11.79 13.94-19.08 2.49-5.79 6.6-20.8-.44-25-4.2-2.48-11.43-2.65-16.19-3.79q-8.46-2.04-16.83-4.37z",
    transform: "translate(-37.28 -37.72)",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.77 218.63a49.49 49.49 0 01-.88-5.54 31.54 31.54 0 01.57-5.48c.92-6.69 0-13.48-.4-20.23s-.44-13.72 2.1-20a15 15 0 014.75-6.62c2.58-1.88 5.85-2.49 9-2.86 4-.47 8.2-.64 12 .8a8 8 0 00-4 5 21.14 21.14 0 00-.6 6.58 121.61 121.61 0 002.45 21.09c1.41 6.91 3.37 14.21 1 20.85-1.33 3.7-3.9 6.79-5.85 10.21-1.29 2.27-2.88 5.07-5.5 5a10.26 10.26 0 01-2.39-.56 15.12 15.12 0 00-5.92 0c-1.3.18-4.11 1.13-5.29.43-2.04-1.12-.73-6.66-1.04-8.67z",
    transform: "translate(-37.28 -37.72)",
    fill: "url(#d)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.65,
    y: 120.56,
    width: 146.87,
    height: 113.13,
    rx: 15.46,
    fill: "#4b39ef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115.65,
    y: 120.56,
    width: 146.87,
    height: 113.13,
    rx: 15.46,
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M115.65 145.86h146.87v65.16H115.65z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 191.89,
    y: 170.82,
    width: 78.6,
    height: 29.97,
    rx: 10.82,
    fill: "url(#g)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 193.49,
    y: 162.38,
    width: 78.6,
    height: 29.97,
    rx: 10.82,
    fill: "#4b39ef"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208.42,
    cy: 177.12,
    r: 9.97,
    fill: "url(#h)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.59,
    cy: 213.41,
    r: 21.56,
    fill: "#f8c244"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.6,
    cy: 213.42,
    r: 18.38,
    fill: "#e8a825"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.91 224.99v-2.95a8.56 8.56 0 01-4.46-1.28l.7-2a7.72 7.72 0 004.17 1.25c2.09 0 3.48-1.19 3.48-2.85s-1.13-2.6-3.29-3.48c-3-1.17-4.82-2.51-4.82-5s1.72-4.26 4.41-4.7v-2.94h1.81v2.82a8 8 0 013.79 1l-.72 2a7 7 0 00-3.67-1c-2.25 0-3.09 1.35-3.09 2.51 0 1.52 1.08 2.27 3.61 3.33 3 1.22 4.52 2.74 4.52 5.33a5.06 5.06 0 01-4.6 5v3z",
    fill: "#f8c244"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.45 242.33a18.81 18.81 0 00-.64 12.32c.91 3.1 2.61 5.92 3.53 9a7.54 7.54 0 01.38 2.79c-.19 1.89-1.53 3.44-2.8 4.85 1.71.35 3.44-.44 5-1.29a18.24 18.24 0 006.23-5 17 17 0 002.46-5.64 36.64 36.64 0 000-18.94c-.63-2.31-3.11-8.68-6.39-7.19s-6.42 5.77-7.77 9.1z",
    transform: "translate(-37.28 -37.72)",
    fill: "url(#i)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.92,
    cy: 214,
    r: 21.56,
    fill: "#f8c244"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.92,
    cy: 214,
    r: 18.38,
    fill: "#e8a825"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.32 221.93l1.86-2.29a8.55 8.55 0 01-2.66-3.8l1.77-1.08a7.75 7.75 0 002.46 3.6c1.62 1.31 3.45 1.26 4.5 0s.75-2.73-.37-4.77c-1.58-2.79-2.16-5-.57-7s4-2.22 6.38-.87l1.85-2.29 1.41 1.14-1.78 2.19a8 8 0 012.31 3.18l-1.76 1.08a7.07 7.07 0 00-2.23-3.08c-1.75-1.42-3.25-.9-4 0-1 1.18-.59 2.45.71 4.86 1.57 2.84 1.79 5 .16 7a5.08 5.08 0 01-6.7 1l-1.94 2.31z",
    fill: "#f8c244"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.75,
    cy: 90.64,
    r: 21.56,
    fill: "#f8c244"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.75,
    cy: 90.63,
    r: 18.38,
    fill: "#e8a825"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.85 102.28l-.7-2.86a8.52 8.52 0 01-4.64-.19l.22-2.07a7.77 7.77 0 004.35.23c2-.49 3.1-2 2.71-3.59s-1.72-2.26-4-2.6c-3.17-.44-5.27-1.31-5.87-3.77s.66-4.54 3.17-5.6l-.7-2.86 1.76-.43.67 2.74a7.93 7.93 0 013.93.1l-.24 2.07a7 7 0 00-3.8-.1c-2.19.53-2.69 2-2.41 3.17.36 1.47 1.59 2 4.3 2.37 3.21.48 5 1.6 5.65 4.12a5.07 5.07 0 01-3.3 5.91l.72 3z",
    fill: "#f8c244"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.54 173.59a39.41 39.41 0 0023.86 6 95.74 95.74 0 00-3.69 23.6 8.06 8.06 0 00.6 4c.91 1.73 2.88 2.61 4.76 3.14a26.94 26.94 0 0010.34.85 146.18 146.18 0 01-2.42-20c-.16-5.47.3-10.92.44-16.38.06-2.33.51-5.35 0-7.63s-3-3.52-4.56-5a20.62 20.62 0 01-5.38-8.66 10.61 10.61 0 01-.41-5.72c.58-2.24 2.22-4.06 3-6.23s.32-5.23-1.92-5.85c-1.7-.47-3.78.71-5.19-.37-.5-.39-.8-1-1.33-1.37a2.5 2.5 0 00-3 .54 9.82 9.82 0 00-1.68 2.84 24.2 24.2 0 01-9.63 9.89 44.77 44.77 0 01-8.11 3.66c-2.12.75-5.47.93-7.29 2.15-2.08 1.39-.37 4.9.55 7.14a30 30 0 0011.06 13.4z",
    transform: "translate(-37.28 -37.72)",
    fill: "url(#j)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.05 171.28a1.83 1.83 0 00.79.55c4.38 1.94 9.34 2 14.14 2a1.83 1.83 0 00.92-.15 1.3 1.3 0 00.39-1.65 3.5 3.5 0 00-1.31-1.28 30.79 30.79 0 00-4.4-2.41c-1.21-.53-2.57-1.11-3.06-2.33a9 9 0 01-.34-2c-.46-2.81-4.87-1.43-6.35 0-1.32 1.35-1.77 5.86-.78 7.27z",
    fill: "#fcab9a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.72 105.51s-2.74 14 9.32 19.86c8.36 4.06 18.48 4.8 27.62 5.15 1.61.06 3.41-.1 5 .12 3.18.41 2.26 2.42 1.88 5.09q-1.29 10.14-2.76 20.24a24.09 24.09 0 00.15 10.62l9.61-1.29a177.65 177.65 0 015.49-29c1.14-4.12 2.72-9.25.36-13.18a21.85 21.85 0 00-9.51-8l-24.16-11.27z",
    fill: "#473f47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M231.77 67.99c2.7-1.1 5.78-2.12 8.47-1a3.13 3.13 0 011.62 1.36 3 3 0 01-1.1 3.47 9.32 9.32 0 01-3.67 1.39c-2.32.53-4.62 1.18-6.89 1.93a4.55 4.55 0 00-1.11.48 4.74 4.74 0 00-1 1 39.38 39.38 0 01-7.13 6.64c.72-.52.46-5.29.65-6.28a3.78 3.78 0 011.94-2.92c2.95-1.88 4.89-4.71 8.22-6.07zm-6.59-24.96c.36.84 1.25 1.42 1.46 2.33s-.62 2.06-1.14 3.09c-.69 1.38-.74 3-1.44 4.42a1.68 1.68 0 01-.61.76 2.15 2.15 0 01-.82.2 11.07 11.07 0 01-3.3-.23 1.06 1.06 0 00-.63-.08.87.87 0 00-.36.52 17.58 17.58 0 00-.94 8.38c.12.92.24 2.06-.51 2.62a1.72 1.72 0 01-.9.32c-2.15.24-4-1.56-5.16-3.34a24.52 24.52 0 01-2.57-5.18 4.53 4.53 0 01-.35-1.66 5.25 5.25 0 01.5-1.94 36 36 0 002-6.82c.55-3 .79-6.14 2.22-8.78a4.86 4.86 0 012.13-2.1 6.08 6.08 0 013.25-.12 8.67 8.67 0 015.81 2.76c.4.59.9 3.8 1.36 4.85z",
    fill: "#fcab9a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M220.08 106.28a13 13 0 01-5.2 2 28.44 28.44 0 00-7.55 2.93c-1.42.85-2.38 2.3-3.63 3.38a8.83 8.83 0 01-7.27 1.95c-.12-.35-.25-.71-.37-1.07-4-12-3.36-25-2.17-37.41.57-5.88 5.19-24.71 14.06-22.52 0 0 8.41 5.81 10.66 9.78 2.05 3.67 5 6.62 4.49 11.15-.74 6.37-4.15 12-4.48 18.63a6 6 0 00.34 2.84c.61 1.29 2.05 2.06 2.65 3.34a4.33 4.33 0 01-1.53 5z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65 96.08a8.37 8.37 0 001 2.55 8.12 8.12 0 005.16 3 61.1 61.1 0 007 1.27c3.48.44 6.27 2 9.9.64a18 18 0 006.49-4.72c.56-.59 1-1.71.3-2.08a1.57 1.57 0 00-.61-.1h-6.05c-.12-.48.23-.94.47-1.37s.34-1.09-.1-1.33-.81.07-1.15.31a12.85 12.85 0 01-11.75 1.39c-3.56-1.35-3.83-5.78-4.35-9.17a2.67 2.67 0 00-1.13-2.15 2.26 2.26 0 00-1.75.08 8.65 8.65 0 00-4.9 3.92c-.89 1.89.92 5.67 1.47 7.76z",
    fill: "#fcab9a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M208.54 67.4s5.88 15.42 7 16.55-10.94 8.12-10.94 8.12-8.06-15-7.76-21.5 7.17-9.29 11.7-3.17z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.82 38.21c-1.87 2.81-3.59 1.11-5.72-.77l.62 2.64-3.65 1.67-2-1.88c.48 2.23-.39 4.5-1.11 6.67-1.06 3.19-1.8 6.69-.72 9.87.88 2.6 2.94 4.9 2.87 7.64l-4.26-4a13.74 13.74 0 00-3.43-2.63 4.72 4.72 0 00-4.1-.14 7.55 7.55 0 00-1.55 1.27c-2.18 2.16-4.67 4.19-5.94 7.06-1.12 2.51-1.09 5.66-3 7.85-2.6 3.07-7.55 2.26-11.14.47a16.56 16.56 0 01-6.31-5 11.16 11.16 0 012.81-15.54 11.28 11.28 0 012.95-1.46c1.75-.56 3.8-.79 4.92-2.25 1.33-1.74.6-4.21.68-6.4a8.24 8.24 0 014.38-6.9c3.53-1.82 8.5-1.19 10.82-4.41a31.31 31.31 0 001.78-3.69c2.13-4 8.35-4.92 11.57-1.74a7.2 7.2 0 002.23 1.91 6.12 6.12 0 002.08.24 6.86 6.86 0 015.87 3.11c.93 1.65.52 4.55-.47 6.15z",
    fill: "#fc682d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240.33 168.33a5.9 5.9 0 00-.83 3.91 2.09 2.09 0 00.48 1.19 2.43 2.43 0 001.07.52 53.62 53.62 0 0015.4 2.38 5.21 5.21 0 002-.27 2 2 0 001.29-1.43 2.51 2.51 0 00-.24-1.32 6.25 6.25 0 00-8.18-3.32l-.18.08a9 9 0 01-1.65.73 5 5 0 01-1.72 0 26.8 26.8 0 01-4.35-.87 32.24 32.24 0 01-3.09-1.6z",
    fill: "#473f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.94678e41e2bd95ca34ceeaa822acade7.svg";
export { ForwardRef as ReactComponent };